import React from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-synergia-line mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="font-montserrat font-bold text-2xl tracking-wide text-synergia-graphite">
              SYNERGIA
            </div>
            <p className="mt-5 font-inter text-sm leading-relaxed text-synergia-graphite/70 max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow">{t.footer.navigation}</div>
            <ul className="mt-6 space-y-3 font-inter text-sm">
              <li><Link to="/sobre" className="text-synergia-graphite hover:text-synergia-green transition-colors" data-testid="footer-link-about">{t.nav.about}</Link></li>
              <li><Link to="/solucoes" className="text-synergia-graphite hover:text-synergia-green transition-colors" data-testid="footer-link-solutions">{t.nav.solutions}</Link></li>
              <li><Link to="/setores" className="text-synergia-graphite hover:text-synergia-green transition-colors" data-testid="footer-link-sectors">{t.nav.sectors}</Link></li>
              <li><Link to="/projetos" className="text-synergia-graphite hover:text-synergia-green transition-colors" data-testid="footer-link-projects">{t.nav.projects}</Link></li>
              <li><Link to="/insights" className="text-synergia-graphite hover:text-synergia-green transition-colors" data-testid="footer-link-insights">{t.nav.insights}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow">{t.footer.contact}</div>
            <ul className="mt-6 space-y-3 font-inter text-sm text-synergia-graphite">
              <li>
                <a
                  href="mailto:contato@synergiaengenharia.com.br"
                  className="hover:text-synergia-green transition-colors"
                  data-testid="footer-email"
                >
                  contato@synergiaengenharia.com.br
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="inline-flex items-center gap-2 hover:text-synergia-green transition-colors"
                  data-testid="footer-linkedin"
                >
                  <Linkedin size={16} /> LinkedIn
                </a>
              </li>
              <li>
                <Link
                  to="/contato"
                  className="inline-block mt-2 text-synergia-green font-semibold link-underline"
                  data-testid="footer-cta"
                >
                  {t.nav.contactCta}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-synergia-line flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="font-inter text-xs text-synergia-graphite/60">
            © {year} SYNERGIA. {t.footer.rights}
          </div>
          <div className="font-inter text-xs text-synergia-graphite/60 tracking-widest uppercase">
            Strategic Engineering Consulting
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
